export const SET_TEMPLATES = 'setTEmplates';

export const GET_TEMPLATES = 'templates';

export const ACTION_GET_TEMPLATES = 'getTemplates';
export const ACTION_CREATE_TEMPLATE = 'createTemplate';
export const ACTION_UPDATE_TEMPLATE = 'updateTemplate';
export const ACTION_REMOVE_TEMPLATE = 'removeTemplate';
